import request from '@/utils/request.js'

export function querylist(data){
    return request({
        url: 'xxtx/wx/advert/list',
        method: 'post',
        data
    })
}


export function add(data){
    return request({
        url: 'xxtx/wx/advert/add',
        method: 'post',
        data
    })
}

export function edit(data){
    return request({
        url: 'xxtx/wx/advert/edit',
        method: 'post',
        data
    })
}

export function deleteById(id){
    return request({
        url: 'xxtx/wx/advert/'+id,
        method: 'DELETE',
        data
    })
}